import type {ReactAction} from '@netx/core/bootstrap';
import {faCalendar} from '@fortawesome/pro-solid-svg-icons';
import {canManageSavedCartExpiration} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionManageExpirationIcon = faCalendar;

/**
 * Manage saved cart assets expiration
 * @param params
 * @returns Action
 */
export const cartSavedActionManageExpiration = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-manage-expiration',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.MANAGE_EXPIRATION, savedCart),
	enableTest: () => canManageSavedCartExpiration(savedCart),
	icon: cartSavedActionManageExpirationIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.MANAGE_EXPIRATION;
	},
	...params,
});

export default cartSavedActionManageExpiration;
